module.exports = __webpack_public_path__ + "static/media/ic_cpf_regular.f6a65204.svg";